import { Component, HostListener, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { MatAccordion } from '@angular/material/expansion';

const ALL_NOTES = [
  'A',
  'A# / Bb',
  'B',
  'C',
  'C# / Db',
  'D',
  'D# / Eb',
  'E',
  'F',
  'F# / Gb',
  'G',
  'G# / Ab',
];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'fretboard';

  @ViewChild(MatAccordion) accordion: MatAccordion;

  selectedNotes$ = new BehaviorSubject([
    { selected: false, note: 'A' },
    { selected: false, note: 'A# / Bb' },
    { selected: false, note: 'B' },
    { selected: false, note: 'C' },
    { selected: false, note: 'C# / Db' },
    { selected: false, note: 'D' },
    { selected: false, note: 'D# / Eb' },
    { selected: false, note: 'E' },
    { selected: false, note: 'F' },
    { selected: false, note: 'F# / Gb' },
    { selected: false, note: 'G' },
    { selected: false, note: 'G# / Ab' },
  ]);

  scaleModeOptions = ['Major', 'Minor'];
  scaleKeyOptions = ALL_NOTES;

  scaleSelection$ = new BehaviorSubject<{
    key: string;
    mode: string;
  }>({
    key: undefined,
    mode: undefined,
  });

  allNotesSelected$ = this.selectedNotes$.pipe(
    map((notes) => {
      return notes.every((n) => n.selected);
    })
  );

  fretboardNotes$ = this.selectedNotes$.pipe(
    map((notes) => {
      return notes.filter((n) => n.selected).map((n) => n.note);
    })
  );

  selectModeOpen$ = new BehaviorSubject<boolean>(false);

  toggleAll() {
    const current = this.selectedNotes$.getValue();
    let next = current;
    if (current.some((n) => n.selected) && current.some((n) => !n.selected)) {
      next = current.map((c) => {
        return {
          ...c,
          selected: true,
        };
      });
    }

    if (current.every((n) => !n.selected) || current.every((n) => n.selected)) {
      next = current.map((c) => {
        return {
          ...c,
          selected: !c.selected,
        };
      });
    }

    this.selectedNotes$.next(next);
  }

  selectionChanged(note) {
    const notes = this.selectedNotes$.getValue().map((n) => {
      if (n.note === note.note) {
        return { ...note, selected: !n.selected };
      }
      return n;
    });

    this.selectedNotes$.next(notes);
  }

  @HostListener('document:click', ['$event'])
  externalClick(event) {
    // Hack. TODO: Do this correctly.
    if (event.target === 'Scale / Mode') {
      return;
    } else {
      this.selectModeOpen$.next(false);
    }
  }

  modeSelected(mode) {
    const scaleNotes = ['G', 'A', 'B', 'C', 'D', 'E', 'F# / Gb'];
    const currentNotes = this.selectedNotes$.getValue();
    const newNotes = currentNotes.map((n) => {
      const include = scaleNotes.includes(n.note);
      return {
        ...n,
        selected: include,
      };
    });

    this.selectedNotes$.next(newNotes);
  }

  selectMode(event) {
    this.selectModeOpen$.next(true);
    event.preventDefault();
    event.stopPropagation();
  }
}
